module.exports = __webpack_public_path__ + "i18n/en_ca192c7ae87b7024cd8df9b1d50b3c62.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/m_en.properties
// module id = A5Ct
// module chunks = 118